// Chakra Icons
import { ChevronDownIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Avatar,
  Box,
  Button,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  FlexProps,
  Portal,
} from "@chakra-ui/react";
// Assets
import avatar1 from "../../assets/img/avatars/avatar1.png";
import avatar2 from "../../assets/img/avatars/avatar2.png";
import avatar3 from "../../assets/img/avatars/avatar3.png";
import avatar4 from "../../assets/img/avatars/avatar4.png";
// Custom Icons
import { ProfileIcon, CreditIcon } from "../Icons/Icons";
// Custom Components
import { ItemContent } from "../Menu/ItemContent";
import SidebarResponsive from "../Sidebar/SidebarResponsive";
import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import routes from "../../routes";
import { RouteConfigArray } from "../../types/routes";
import { useClerkAuth } from "../../hooks/useClerkAuth";

interface AdminNavbarLinksProps extends FlexProps {
  variant?: string;
  children?: React.ReactNode;
  fixed?: boolean;
  secondary?: boolean;
  logoText?: string;
  onOpen?: () => void;
}

export default function HeaderLinks(props: AdminNavbarLinksProps) {
  const { variant, children, fixed, secondary, onOpen, logoText, ...rest } = props;
  const history = useHistory();
  const { signOut, isLoaded, user } = useClerkAuth();
  const [isSigningOut, setIsSigningOut] = useState(false);
  const profileCardRef = useRef<HTMLButtonElement>(null);
  const [cardWidth, setCardWidth] = useState<number | undefined>(undefined);
  
  // Fixed height for all icon boxes (settings, notifications, profile)
  const iconBoxHeight = "48px";
  
  // Get user's avatar image with fallback
  const avatarImage = user?.imageUrl || avatar4;
  
  // Get user's full name and email
  const fullName = user
    ? `${user.firstName || ""} ${user.lastName || ""}`.trim() || "User"
    : "User";
  const email = user?.primaryEmailAddress || user?.emailAddresses?.[0]?.emailAddress || "No email";
  
  // Measure card width after render (for dropdown menu width)
  useEffect(() => {
    if (profileCardRef.current) {
      const width = profileCardRef.current.offsetWidth;
      setCardWidth(width);
    }
  }, [fullName, email]); // Re-measure when content changes
  
  // Handle profile navigation
  const handleProfileClick = () => {
    history.push("/profile");
  };

  // Handle sign out
  const handleSignOut = async () => {
    setIsSigningOut(true);
    try {
      // Sign out first
      await signOut();
      // Immediately navigate to prevent ProtectedRoute from flashing
      window.location.assign("/auth/signin");
    } catch (error) {
      console.error("Sign out error:", error);
      setIsSigningOut(false);
    }
  };

  // Chakra Color Mode
  let mainTeal = useColorModeValue("teal.300", "teal.300");
  let inputBg = useColorModeValue("white", "gray.800");
  let mainText = useColorModeValue("gray.700", "gray.200");
  let navbarIcon = useColorModeValue("gray.500", "gray.200");
  let searchIcon = useColorModeValue("gray.700", "gray.200");
  let cardBg = useColorModeValue("white", "#151517");
  let cardBorder = useColorModeValue("gray.200", "gray.600");
  let cardText = useColorModeValue("gray.700", "gray.200");
  let cardTextSecondary = useColorModeValue("gray.500", "gray.400");
  let cardHoverBg = useColorModeValue("gray.50", "gray.600");
  let cardHoverBorder = useColorModeValue("gray.300", "gray.500");
  let cardActiveBg = useColorModeValue("gray.100", "gray.600");

  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }
  return (
    <Flex
      pe="0px"
      w={{ sm: "100%", xl: "auto" }}
      alignItems="center"
      flexDirection="row"
      {...rest}
    >
      {/* Search bar hidden for now */}
      {/* <InputGroup
        cursor="pointer"
        bg={inputBg}
        borderRadius="15px"
        w={{
          sm: "128px",
          md: "200px",
        }}
        me={{ sm: "auto", md: "20px" }}
        _focus={{
          borderColor: mainTeal,
        }}
        _active={{
          borderColor: mainTeal,
        }}
      >
        <InputLeftElement
          children={
            <IconButton
              aria-label="Search"
              bg="inherit"
              borderRadius="inherit"
              _hover={{ bg: "inherit" }}
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{
                boxShadow: "none",
              }}
              icon={<SearchIcon color={searchIcon} w="15px" h="15px" />}
            ></IconButton>
          }
        />
        <Input
          fontSize="xs"
          py="11px"
          color={mainText}
          placeholder="Type here..."
          borderRadius="inherit"
        />
      </InputGroup> */}
      <SidebarResponsive
        logoText={logoText}
        secondary={secondary}
        routes={routes as RouteConfigArray}
        onOpen={onOpen}
        {...rest}
      />
    </Flex>
  );
}

